import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SaldoPermissionConstants} from '../../../app.constants';
import {TableColumn} from '../../../modules/common/models/table.column.model';
import {CashflowClassifierTree} from '../../../models/cashflow-classifier-tree';
import {CashflowClassifierService} from '../../../services/cashflow-classifier.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {UserInfoService} from '../../../services/userinfo.service';
import {ArrayUtils} from '../../../utils/ArrayUtils';
import {DownloadSetup} from '../../../utils/DownloadSetup';
import {MediaTypeConstant} from '../../../models/media-type-constant';

@Component({
  selector: 'saldo-source-cashflow',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './cashflow.component.html',
  styleUrls: ['./cashflow.component.scss']
})
export class CashflowComponent implements OnInit {
  isAdministrator = false;

  list: CashflowClassifierTree[];
  columns: TableColumn[];
  loaded = false;
  dwnLoaded = true;


  constructor(private router: Router,
              private route: ActivatedRoute,
              private cashflowClassifierService: CashflowClassifierService,
              private userInfoService: UserInfoService,
              private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    const userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    if (userInfo) {
      this.isAdministrator = this.userInfoService.hasRoleWithUserInfo(SaldoPermissionConstants.ADMINISTRATOR, userInfo);
    }
    this.columns = this.getColumns();
    this.refreshTable();
  }

  goToEditPage(id) {
    this.router.navigate(['muuda/' + id], {queryParams: {id}, relativeTo: this.route});
  }

  goToNewAccountClassifier(code) {
    if (code) {
      this.router.navigate(['uus'], {queryParams: {code}, relativeTo: this.route});
    } else {
      this.router.navigate(['uus'], {relativeTo: this.route});
    }
  }

  deleteItem(id) {
    this.cashflowClassifierService.removeCashflowClassifier(id).subscribe(() => {
      ArrayUtils.removeRow(this.list, id);
      this.toastr.success('Rahavoog eemaldatud.', 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    }, error => {
      this.toastr.error(this.translate.instant(error), 'Teade', {
        positionClass: 'toast-top-right', closeButton: true, tapToDismiss: false
      });
    });
  }

  refreshTable() {
    this.cashflowClassifierService.getCashflowClassifiers().subscribe(res => {
      this.list = res.child;
      this.loaded = true;
    });
  }

  getColumns(): TableColumn[] {
    return [
      {
        name: 'title',
        label: 'Nimetus',
      },
      {
        name: 'code',
        label: 'Kood'
      },
      {
        name: 'validTo',
        label: 'Kehtiv kuni',
      }];
  }

  saveAsExcel() {
    this.dwnLoaded = false;
    this.cashflowClassifierService.downloadExcel().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.EXCEL, response, 'Rahavood.xls');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  saveAsXml() {
    this.dwnLoaded = false;
    this.cashflowClassifierService.downloadXml().subscribe(response => {
      DownloadSetup.setupDownloadProperties(MediaTypeConstant.XML, response, 'Rahavood.xml');
      this.dwnLoaded = true;
    }, () => {
      this.dwnLoaded = true;
    });
  }

  hasAdministratorRole() {
    return this.isAdministrator;
  }
}
